.stack {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-4);
  flex-wrap: wrap;
  padding: var(--spacing-5);
}

.headerMain {
  display: flex;
  align-items: center;
  gap: var(--spacing-4);
  min-width: 0;
}

.statusIcon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.diagnosis {
  margin-top: var(--spacing-3);
}

.titleRow {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  flex-wrap: wrap;
}

.name {
  margin: 0;
  font-size: var(--font-size-xl);
  font-weight: inherit;
  letter-spacing: -0.01em;
  color: var(--color-text);
  overflow-wrap: anywhere;
}

.sub {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  margin-top: 8px;
  color: var(--color-grey);
  font-size: var(--font-size-m);
  min-width: 0;
}

.subId {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: var(--font-size-s);
  color: var(--color-grey-light);
}

.actions {
  display: flex;
  gap: var(--spacing-2);
  flex-shrink: 0;
}

.profiles {
  display: flex;
  align-items: center;
  gap: var(--spacing-3);
  flex-wrap: wrap;
}

.eyebrow {
  font-size: var(--font-size-s);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-grey-light);
}

.profileSelect {
  width: 50%;
  min-width: 260px;
  max-width: 100%;
}

.multiHint {
  font-size: var(--font-size-s);
  color: var(--color-grey);
}

.roleTags {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: var(--spacing-2);
}

.profileName {
  font-size: var(--font-size-m);
  color: var(--color-text);
}

.head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-3);
  margin-bottom: var(--spacing-3);
}

/* Same size as the DS card headline, so custom card heads look like the others. */
.headTitle {
  margin: 0;
  flex: 1;
  min-width: 0;
  font-size: var(--font-size-xl);
  font-weight: inherit;
  color: var(--color-text);
}
